import SInput from './s-input'

export default SInput
